/**
 * Environment, read once.
 *
 * Vite inlines `import.meta.env` at build time, so a variable that is not set
 * becomes `undefined` in the bundle rather than failing loudly. Everything here
 * therefore has a working default, and the portal runs from a fresh clone with
 * no .env.local at all.
 *
 * If a portal ever needs a genuinely mandatory variable - a Stripe key, a Sentry
 * DSN it cannot start without - throw for it explicitly:
 *
 *   if (!import.meta.env.VITE_SENTRY_DSN) {
 *     throw new Error('Missing VITE_SENTRY_DSN. Copy .env.example to .env.local.');
 *   }
 *
 * Fail at module load, not at first use: a missing key should stop the app on
 * the first page rather than surface as a confusing error three screens in.
 */
export const env = {
  /**
   * Empty in development on purpose: vite.config.ts proxies /api to the server,
   * so requests are same-origin and CORS never applies locally. Production
   * builds set this to the real API origin.
   */
  apiBaseUrl: import.meta.env.VITE_API_BASE_URL ?? '',
  /**
   * Stylised with a Greek mu, as the logo and the design canvas both spell it.
   * Overridable, so a deploy that wants the plain ASCII spelling can set
   * VITE_APP_NAME rather than patching this.
   */
  appName: import.meta.env.VITE_APP_NAME || 'NμDent',
  environment: import.meta.env.VITE_ENVIRONMENT ?? 'development',
  isProduction: import.meta.env.PROD,
  isDevelopment: import.meta.env.DEV,
} as const;
